import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdvisorRegistrationComponent } from "../../advisor-panel/advisor-registration/advisor-registration.component";
import { LoginComponent } from '../../modals/login/login.component';
import { GlobalService } from '../../service/global.service';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../service/http.service';
import { ToastrService } from 'ngx-toastr';

declare var bootstrap: any;

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule, AdvisorRegistrationComponent, LoginComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

  isLoginPopup: boolean = false;
  loginPopuptype: string = 'login';

  // Footer menus — mirror the header dropdowns
  businessMenu = [
    { name: 'Private Limited Company', url: '/products/startup/Private-limited-company' },
    { name: 'Limited Liability Partnership', url: '/products/startup/Limited-Liability-Partnership' },
    { name: 'One Person Company', url: '/products/startup/One-person-company' },
    { name: 'Sole Proprietorship', url: '/products/startup/Sole-Proprietorship' },
    { name: 'Partnership Firm Registration', url: '/products/startup/Partnership-Firm-Registration' },
    { name: 'Rent Agreement', url: '/products/agreement/Rent-Agreement' },
    { name: 'ITR Filing', url: '/products/tax-and-compliance' },
    { name: 'GST Filing', url: '/products/gst-filing' },
  ];

  complianceMenu = [
    { name: 'GST Registration', url: '/products/startup/GST-Registration' },
    { name: 'MSME Registration', url: '/products/startup/MSME-Registration' },
    { name: 'Provident Fund (PF) Registration', url: '/products/human-resource/PF-Provident-Fund' },
    { name: 'ESIC Registration', url: '/products/human-resource/ESIC' },
    { name: 'TDS Filling', url: '/products/human-resource/TDS-Filling' },
    { name: 'GST', url: '/gst' },
  ];

  constructor(private http: HttpService, public gS: GlobalService, private toastr: ToastrService, private fb: FormBuilder) {

    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  closeLoginPopup() {
    this.isLoginPopup = false;
  }

  openLoginPopup(login: string) {
    this.isLoginPopup = true;
    this.loginPopuptype = login;
  }

  email: string = '';
  emailForm: FormGroup;
  userIdForOTP: any;
  validateEmail() {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }

    const payload = {
      timeZone: this.gS?.timeZone,
      email: this.emailForm.value.email,
    };

    this.http.emailValidation(payload).subscribe((res: any) => {
      if (res?.status === 'success') {
        this.toastr.success(res.message);
        this.emailForm.reset();
      } else {
        this.toastr.error(res.message)
      }
    });
  }

  @ViewChild('appStoreBtn', { static: false })
  appStoreBtn!: ElementRef;

  ngAfterViewInit(): void {
    new bootstrap.Tooltip(this.appStoreBtn.nativeElement, {
      title: 'Coming Soon',
      placement: 'top',
      trigger: 'hover focus'
    });
  }

  isOpen = false;

  openModal() {
    this.isOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.isOpen = false;
    document.body.style.overflow = '';
  }
}
